import Configs from '@/components/configs/Configs'
import ConfigCreate from '@/components/configs/ConfigCreate'
import ConfigUpdate from '@/components/configs/ConfigUpdate'

const configsRoutes = [
  { path: '/configs', name: 'configs', component: Configs },
  { path: '/configs/create', name: 'config_create', component: ConfigCreate },
  { path: '/configs/update/:id', name: 'config_update', component: ConfigUpdate }
]

export default configsRoutes



// WEBPACK FOOTER //
// ./src/router/configs_routes.js